import { jsx, jsxs } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { useId } from '@radix-ui/react-id';
import { forwardRef, useState, useCallback } from 'react';
import '../../utils/styles/flex.mjs';
import Stack from '../../utils/styles/stack.mjs';
import { BaseTextField } from './base/textField/BaseTextField.mjs';
import { TextFieldProvider } from './base/textField/context.mjs';
import HelperText from './base/textField/HelperText.mjs';
import LabelImpl from './base/textField/Label.mjs';
import PasswordTextField from './PasswordTextField.mjs';
import { root } from './textField.vanilla.mjs';

const InnerTextField = forwardRef(
  ({
    __scopeTextField,
    size = "default",
    required = false,
    variant = "outline",
    helperText,
    ...props
  }, forwardedRef) => {
    const [describeBy, _setDescribedBy] = useState();
    const [labelledBy, _setLabelledBy] = useState();
    const setDescribedBy = useCallback((describeById) => {
      _setDescribedBy(describeById);
    }, []);
    const setLabelledBy = useCallback((labelledById) => {
      _setLabelledBy(labelledById);
    }, []);
    const inputId = useId(props?.id);
    const TextFieldComponent = props.type === "password" ? PasswordTextField : BaseTextField;
    return /* @__PURE__ */ jsx(
      TextFieldProvider,
      {
        scope: __scopeTextField,
        size,
        required,
        state: props.state,
        disabled: props.disabled,
        setDescribedBy,
        setLabelledBy,
        children: /* @__PURE__ */ jsxs(
          Stack.Vertical,
          {
            className: root,
            space: 8,
            "data-scope": "text-field",
            "data-part": "root",
            children: [
              /* @__PURE__ */ jsx(
                TextFieldComponent,
                {
                  ...props,
                  variant,
                  id: inputId,
                  size,
                  required,
                  describeBy,
                  labelledBy,
                  ref: forwardedRef
                }
              ),
              helperText
            ]
          }
        )
      }
    );
  }
);
const TextField = Object.assign({}, InnerTextField, {
  Label: styled(LabelImpl),
  HelperText: styled(HelperText)
});

export { TextField as default };
//# sourceMappingURL=TextField.mjs.map
